<template>
	<div class="w1200 addresDetal">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1">
			<div class="flex addresDetal_1">
				<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
					<img class="addresDetal_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
					<div class="addresDetal_1_2">{{$t('返回')}}</div>
				</div>
			</div>
			<div class="flex benben-flex-layout flex-wrap align-center addresDetal_2">
				<div class="addresDetal_2_1">{{$t('设置')}}</div>
				<img class="addresDetal_2_2" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
				<div class="addresDetal_2_3">{{$t('修改绑定邮箱号')}}</div>
			</div>
		
			<div class=" password_2" > 
				<div class="flex flex-direction align-center benben-flex-layout password_3_1" v-if="cao_type == 1">
					<div class="password_3_2">{{$t('我们要对您绑定的邮箱号进行验证')}}</div>
					<div class="password_3_3">{{userInfo.email}}</div>
				</div>
				<div class="password_3_8" v-if="cao_type == 2">
					<div class="password_2_1">{{$t('新的邮箱号')}}</div>
					<div class="flex benben-flex-layout flex-wrap align-center login_7">
						<el-input class="flex-sub" v-model="email" :placeholder="$t('请输入邮箱号')"></el-input>
					</div>
				</div>
				<div class="password_3_9" >
					<div class="password_2_1" >{{$t('验证码')}}</div>
					<div class="flex benben-flex-layout flex-wrap align-center">
						<el-input class="password_3_7"  v-model="input1" :placeholder="$t('请输入验证码')"></el-input>
						<div class="password_3_4 pointer">
							<div @click="tioCod" v-if="!timTpe">{{$t('获取验证码')}}</div>
							<div v-else>{{time}}{{$t('秒后重新获取')}}</div>
						</div>
					</div>
				</div>
				<div class="password_3_8">
					<!-- <div class="password_2_1">{{$t('新密码')}}</div>
					<el-input class="password_2_2" v-model="input1" :placeholder="$t('请输入新密码')"></el-input>
					<div class="password_2_1">{{$t('确认新密码')}}</div>
					<el-input class="password_2_2" v-model="input1" :placeholder="$t('请再次输入新密码')"></el-input> -->
					<div class="password_2_3 pointer" @click="tijiao">{{$t('确定')}}</div>
				</div>
				
			</div>
			
		
		
		
		
		</div>
		
	
		
	</div>
</template>

<script>
	import CryptoJS from '../api/crypto-js.min.js'
	import ChoiceMenu from "../components/choiceMenu.vue"
	export default {
		components: {
			ChoiceMenu
		},
		data() {
			return {
				cao_type:2,
				input1:'',
				time:60,
				timTpe: false,
				td: '',
				userInfo:'',
				email:'',
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				this.post5c78c4772da97()
			}else{
				this.$router.push({
					name: 'login',
				});
			}
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post5c78c4772da97()
			},
			//个人中心-获取会员详细信息
			post5c78c4772da97(){
				this.$api.post(this.$apiUrls.post5c78c4772da97).then((res) => {
					if(res.code == 1){
						this.userInfo = res.data
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 提交
			tijiao(){
				if(this.cao_type == 1){
					if (!this.input1) {
						this.$message.error(this.$t('请输入验证码'));
						return
					}
					this.post5f6db4db8abcf()
				}else if(this.cao_type == 2){
					if (!this.email) {
						this.$message.error(this.$t('请输入邮箱号'));
						return
					}
					if (!this.input1) {
						this.$message.error(this.$t('请输入验证码'));
						return
					}
					this.$api.post(this.$apiUrls.post68e48e514b1bc,{
						email: this.email,
						code: this.input1,
						type: '4',
					}).then((res) => {
						if(res.code == 1){
							window.history.back();
							return
						}else{
							this.$message.error(res.msg);
							return
						}
					})
				}
			},
			// 校验验证码
			post5f6db4db8abcf(){
				this.$api.post(this.$apiUrls.post5f6db4db8abcf,{
					user_email:this.userInfo.email,
					code:this.input1,
					type:2,
				}).then((res) => {
					if(res.code == 1){
						this.email = ''
						this.input1 = ''
						this.timTpe = false
						clearInterval(this.td);
						this.cao_type = 2
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			// 校验验证码
			post666a45d4d6bb4(key){
				let page = {
					is_test: 1,
					captcha_data: this.getCaptchaData(),
					captcha_key: key,
				}
				if(this.cao_type == 1){ // 旧邮箱
					page.user_email = this.userInfo.email
					page.accountType = 'email'
					page.type = 2
				}else if(this.cao_type == 2){ // 新邮箱
					page.user_email = this.email
					page.accountType = 'email'
					page.type = 5
				}
				this.$api.post(this.$apiUrls.post666a45d4d6bb4, page).then((res) => {
					if (res.code == 1) {
						if (res.data.code) {
							this.$message.success(res.data.code);
						} else {
							this.$message.success('发送成功！');
						}
						let that = this
						this.td = setInterval(function() {
							if (that.time == 0) {
								// 清除定时器和复原按钮
								that.timTpe = false
								clearInterval(that.td);
							} else {
								that.timTpe = true
								that.time--;
							}
						}, 1000);
						this.post_type = false
					} else {
						this.$message.error(res.msg);
						this.post_type = false
					}
				})
			},
			// 获取验证码
			tioCod() {
				if(this.cao_type == 2){
					if (!this.email) {
						this.$message.error(this.$t('请输入邮箱号'));
						return
					}
				}
				this.$api.post(this.$apiUrls.post6668f5d1d434e,{
					captcha_data: this.getCaptchaData()
				}).then((res)=> {
					if (res.code == 1) {
						this.post666a45d4d6bb4(res.data.captcha_key)
					} else {
						this.$message.error(res.msg);
						this.post_type = false
					}
				})
			},
			caozuo(type,item,index){
				if(type == 1){ //返回上一页
					if(this.cao_type == 1){
						window.history.back();
						return
					}else{
						this.cao_type = 1
					}
					
				}else if(type == 2){
					this.cao_type = 2
				}else if(type == 3){
					this.timTpe = false
					clearInterval(this.td);
					this.cao_type = 3
				}else if(type == 4){
					this.timTpe = false
					clearInterval(this.td);
					this.cao_type = 4
				}
			},
			encrypt(text) {
				let key = CryptoJS.enc.Utf8.parse('c81b7d38b57d7dbabcd3c38dc37446f4')
				let srcs = CryptoJS.enc.Utf8.parse(text)
				let encrypted = CryptoJS.AES.encrypt(srcs, key, {
					mode: CryptoJS.mode.ECB,
					padding: CryptoJS.pad.Pkcs7
				})
				return encrypted.toString()
			},
			getUUID() {
				const S4 = () => (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
				return S4() + S4() + '' + S4() + '' + S4() + '' + S4() + '' + S4() + S4() + S4() + new Date().getTime()
			},
			getCaptchaData() {
				let device = ''
			
				let DEVICE_ID = ''
				if (window.sessionStorage.getItem('DEVICE_ID')) {
					DEVICE_ID = window.sessionStorage.getItem('DEVICE_ID')
				}
				// let DEVICE_ID = uni.getStorageSync('DEVICE_ID')
				if (!DEVICE_ID) {
					DEVICE_ID = this.getUUID()
					window.sessionStorage.setItem('DEVICE_ID', DEVICE_ID);
				}
				device = DEVICE_ID
				// 获取当前时间戳单位秒
				return this.encrypt(JSON.stringify({
					device,
					timestamp: Math.floor(new Date().getTime() / 1000)
				}))
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.addresDetal_3_8{
			.el-input__inner{
				height: 40px;
				border: none;
			}
		}
		.el-textarea__inner{
			width: 444px;
			height: 140px;
			background: #FFFFFF;
			border: none;
		}
		.login_7{
			.el-input input {
				height: 20px;
				line-height: 20px;
				margin-top: -10px;
				background: rgba(0, 0, 0, 0);
				border: none;
				padding: 0;
			}
		}
		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
			-webkit-appearance: none;
		}
		
		input[type="number"] {
			-moz-appearance: textfield;
		}
	}
	.addresDetal{
		padding: 20px 0 0 0;
	}
	.addresDetal_1{
		padding: 21px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.addresDetal_1_1{
		width: 14px;
		height: 14px;
		
	}
	.addresDetal_1_2{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
		margin-left: 12px;
	}
	.addresDetal_2{
		margin: 16px 0 0 0;
	}
	.addresDetal_2_1{
		font-weight: 400;
		font-size: 16px;
		color: #666666;
	}
	.addresDetal_2_2{
		width: 8px;
		height: 8px;
		margin: 0 10px;
		transform: rotate(180deg);
	}
	.addresDetal_2_3{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.password_1{
		margin: 80px 0 0 0;
	}
	.password_1_1{
		width: 440px;
		height: 80px;
		border-radius: 12px 12px 12px 12px;
		border: 1px solid #CCCCCC;
		padding: 0 30px;
		margin: 0 0 40px;
	}
	.password_1_2{
		font-weight: bold;
		font-size: 20px;
		color: #333333;
	}
	.password_1_3{
		width: 32px;
		height: 32px;
		margin: 0 0 0 auto;
	}
	.password_2{
		margin: 40px 0 0 0;
	}
	.password_2_1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 0 0 20px 0;
		width: 330px;
	}
	.password_2_2{
		width: 330px;
		height: 40px;
		margin: 0 0 32px 0;
	}
	.password_2_3{
		width: 180px;
		height: 42px;
		background: #FF770F;
		border-radius: 6px 6px 6px 6px;
		text-align: center;
		line-height: 42px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		margin: 10px 0 0 75px;
	}
	.password_3{
		margin: 32px 0 0 0;
	}
	.password_3_1{
		width: 590px;
		// height: 97px;
		background: #FFF7F1;
		border-radius: 4px 4px 4px 4px;
		padding: 20px 0;
		margin: 0 0 26px 195px;
	}
	.password_3_2{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		padding: 0 32px;
	}
	.password_3_3{
		font-weight: 500;
		font-size: 18px;
		color: #333333;
		margin: 12px 0 0 0;
	}
	.password_3_4{
		font-weight: 400;
		font-size: 16px;
		color: #FF770F;
		margin: 0 0 0 0px;
	}
	.password_3_5{
		margin: 0 0 32px 80px;
	}
	.password_3_6{
		margin: 0 0 32px 110px;
	}
	.password_3_7{
		width: 330px;
		height: 40px;
		margin: 0 14px 0px 0;
	}
	.password_3_8{
		margin: 0 0 0 263px;
	}
	.password_3_9{
		margin: 0 0 32px 263px;
	}
	.login_7{
		width: 330px;
		height: 48px;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
		border: 1px solid #DADADA;
		margin: 0px 0 32px 0;
		padding: 0 16px;
		box-sizing: border-box;
	}
	
	.login_7_2{
		// font-weight: bold;
		font-size: 16px;
		color: #1A1A1A;
		margin: 0 10px;
	}
	.login_7_3{
		width: 12px;
		height: 7px;
	}
</style>